// Centralized data-testid registry for SignFlow360
export const AUTH = {
  loginPage: 'auth-login-page',
  signInBtn: 'auth-google-signin-btn',
  logoutBtn: 'auth-logout-btn',
};

export const DASH = {
  page: 'dashboard-page',
  newProjectBtn: 'dashboard-new-project-btn',
  searchInput: 'dashboard-search-input',
  statusFilter: 'dashboard-status-filter',
  projectsList: 'dashboard-projects-list',
  projectCard: (id) => `dashboard-project-card-${id}`,
  openProjectBtn: (id) => `dashboard-open-project-${id}`,
  deleteProjectBtn: (id) => `dashboard-delete-project-${id}`,
  emptyState: 'dashboard-empty-state',
  settingsLink: 'dashboard-settings-link',
};

export const NEW_PROJECT = {
  dialog: 'new-project-dialog',
  customerName: 'new-project-customer-name',
  businessName: 'new-project-business-name',
  phone: 'new-project-phone',
  email: 'new-project-email',
  address: 'new-project-address',
  submitBtn: 'new-project-submit-btn',
  cancelBtn: 'new-project-cancel-btn',
};

export const WS = {
  page: 'workspace-page',
  backBtn: 'workspace-back-btn',
  saveBtn: 'workspace-save-btn',
  exportPdfBtn: 'workspace-export-pdf-btn',
  uploadInput: 'workspace-storefront-upload',
  uploadDropzone: 'workspace-storefront-dropzone',
  canvas: 'workspace-mockup-canvas',
  signText: 'workspace-sign-text',
  dayNightToggle: 'workspace-daynight-toggle',
  exportMockupBtn: 'workspace-export-mockup-btn',
  // Sidebar fields
  customerName: 'ws-customer-name',
  businessName: 'ws-business-name',
  phone: 'ws-phone',
  email: 'ws-email',
  address: 'ws-address',
  status: 'ws-status',
  signType: 'ws-sign-type',
  mainText: 'ws-main-text',
  secondaryText: 'ws-secondary-text',
  excludeSpaces: 'ws-exclude-spaces',
  excludePunct: 'ws-exclude-punct',
  letterCount: 'ws-letter-count',
  letterHeight: 'ws-letter-height',
  areaWidthIn: 'ws-area-width-in',
  areaHeightIn: 'ws-area-height-in',
  areaWidthFt: 'ws-area-width-ft',
  areaHeightFt: 'ws-area-height-ft',
  // Pricing
  pricePerInch: 'ws-price-per-inch',
  installation: 'ws-installation',
  permit: 'ws-permit',
  electrical: 'ws-electrical',
  raceway: 'ws-raceway',
  removal: 'ws-removal',
  misc: 'ws-misc',
  discount: 'ws-discount',
  tax: 'ws-tax',
  total: 'ws-total',
  // Mockup controls
  fontSelect: 'ws-font-select',
  colorPicker: 'ws-color-picker',
  letterSpacing: 'ws-letter-spacing',
  rotation: 'ws-rotation',
  shadowToggle: 'ws-shadow-toggle',
  glowToggle: 'ws-glow-toggle',
  fitWidth: 'ws-fit-width',
  centerText: 'ws-center-text',
  // Notes
  clientNotes: 'ws-client-notes',
  internalNotes: 'ws-internal-notes',
  // AI placeholders
  aiVisionBtn: 'ws-ai-vision-coming-soon',
  aiMockupBtn: 'ws-ai-mockup-coming-soon',
};

export const SETTINGS = {
  page: 'settings-page',
  pricePerInch: 'settings-price-per-inch',
  installation: 'settings-installation',
  permit: 'settings-permit',
  electrical: 'settings-electrical',
  raceway: 'settings-raceway',
  removal: 'settings-removal',
  misc: 'settings-misc',
  saveBtn: 'settings-save-btn',
};
